<template>
  <div class="custom-pagination" v-if="option.total">
    <el-pagination background
                   layout="total, prev, pager, next"
                   :page-size="option.pageSize"
                   :prev-text="option.prevText"
                   :next-text="option.nextText"
                   :current-page="option.currentPage"
                   :total="option.total"
                   @current-change="currentChange"
                   @prev-click="prevClick"
                   @next-click="nextClick">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'pageComponents',
  props: {
    el: {
      // 接收 HTMLElement、VueComponent两种类型
      // 如果el = 带有y轴滚动条el-table Vue实列，则滚动el-table的内部滚动条到顶部
      // 其他情况则滚动该el元素的所在位置
      default: null
    },
    pageOption: {
      type: Object,
      required: true,
      default: () => {
        return {
          total: 0,
          prevText: '上一页',
          nextText: '下一页',
          query: {
            pageSize: 20,
            pageNum: 1
          }
        }
      }
    }
  },
  data () {
    return {
      option: {
        pageSize: this.pageOption.query.pageSize,
        currentPage: this.pageOption.query.pageNum,
        total: this.pageOption.total,
        prevText: this.pageOption.prevText || '上一页',
        nextText: this.pageOption.nextText || '下一页'
      }
    }
  },
  mounted() {
    // 这里获取不到el 第一时间el为null
  },
  methods: {
    currentChange (current) {
      this.$emit('current', current)
      if (this.el) {
        this.scrollTo()
      } else {
        window.scrollTo(0, 0)
      }
    },
    prevClick (current) {
      this.currentChange(current)
      // this.$emit('prev', current)
    },
    nextClick (current) {
      this.currentChange(current)
      // this.$emit('next', current)
    },
    scrollTo () {
      const el = this.el.$el ? this.el.$el : this.el
      const classList = [...el.classList]
      if (classList.includes('el-table--scrollable-y')) {
        this.el.bodyWrapper.scrollTo(0, 0)
      } else {
        window.scrollTo(0, this.getOffsetTop(el))
      }
    },
    // 获取元素到顶部的距离
    getOffsetTop (el, offsetTop = 0) {
      if (el.nodeName === 'BODY') {
        return offsetTop
      }
      offsetTop += el.offsetTop
      return this.getOffsetTop(el.offsetParent, offsetTop)
    }
  },
  watch: {
    pageOption: {
      handler (val, oldVal) {
        this.option.pageSize = this.pageOption.query.pageSize
        this.option.total = this.pageOption.total
        this.option.currentPage = this.pageOption.query.pageNum
        this.option.prevText = this.pageOption.prevText || '上一页'
        this.option.nextText = this.pageOption.nextText || '下一页'
      },
      deep: true
    }
  }
}
</script>
